import React, { useState, useEffect } from "react";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import {
  ManageRestaurant,
  showMessage,
  getToken,
  formatTime,
  random_rgba,
  FirstLetterOfWords,
} from "../../Functionalities/Functions";
import { ManageFranchise } from "./Logic";
import "./Assets/css/restaurants.css";
import FilterComponent from "../../CoreComponents/FilterComponent";
import FilterModalComponent from "../../CoreComponents/FilterModalComponent";
import axios from "axios";
import { is_superuser, protocol } from "../../Functionalities/Config";
import NoDataComponent from "../../CoreComponents/NoDataComponent";
import { ManageFeatured } from "./Logic";
import ToggleButton from "../../CoreComponents/ToggleButton";
import LoadingComponent from "../../CoreComponents/LoadingComponent";

import ProductsList from "../../CoreComponents/ProductsList";

function Body() {
  const [data, setData] = useState({ id: "", name: "", data: [] });
  const [is_blocked, setIs_blocked] = useState({
    id: "",
    is_blocked: "",
  });

  const [next, setNext] = useState("");
  const [prev, setPrev] = useState("");
  const [filter, setfilter] = useState({
    id: "",
    search_text: "",
  });
  const [restrarent, setrestrarent] = useState({ id: "", name: "", data: [] });
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isFilterApplied, setisFilterApplied] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(" franchise_filter")) {
      setfilter(JSON.parse(localStorage.getItem(" franchise_filter")));
      setisFilterApplied(true);
    } else {
      setfilter({ ...filter, id: "", search_text: "" });
    }
  }, []);

  useEffect(() => {
    isFilterApplied && getData();
    setisFilterApplied(false);
  }, [isFilterApplied]);

  useEffect(() => {
    getData();
    is_superuser && getBranches();
  }, [reload]);

  let params = "id=" + filter.id + "&search_text=" + filter.search_text;

  const getData = () => {
    // showMessage(
    //   "Loading franchise",
    //   "info",
    //   "Loading",
    //   "bottom", "bottom-left",
    //   0
    // );

    let result = ManageFranchise("", "", "get", params);
    result
      .then((result) => {
        setData({
          ...data,
          data: result.data.results,
        });
        setLoading(false);
        setNext(result.data.next);
        setPrev(result.data.previous);
      })
      .catch((err) => {
        showMessage(
          JSON.stringify(err),
          "danger",
          "Loading error",
          "top",
          "top-right",
          0
        );
        // void 0
      });
  };

  const handlePrev = () => {
    // alert("prev");

    var config = {
      method: "get",
      url: prev.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const handleNext = () => {
    var config = {
      method: "get",
      url: next.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const getBranches = () => {
    //shabeeb change start
    // showMessage(
    //   "Loading Restaurant",
    //   "info",
    //   "Loading",
    //   "top",
    //   "top-center",
    //   0
    // );
    //shabeeb change end

    let params = "for_dropdown=true&page_wise=false";

    let result = ManageFranchise("", "", "get", params);
    result
      .then((result) => {
        //shabeeb change start

        // showMessage(
        //   JSON.stringify(result),
        //   "success",
        //   "Loading",
        //   "top",
        //   "top-center",
        //   0
        // );

        //shabeeb change end

        setrestrarent({
          ...restrarent,
          data: result?.data,
        });
      })
      .catch((err) => {
        showMessage(
          JSON.stringify(err),
          "danger",
          "Loading error",
          "top",
          "top-right", //shabeeb change
          0
        );
        // void 0
      });
  };
  // void 0
  return (
    <div className="content-body">
      {!loading ? (
        <div className="container-fluid">
          <FilterComponent
            handleNext={handleNext}
            handlePrev={handlePrev}
            next={next}
            prev={prev}
            addItemName={"Add Franchise"}
            addItemPath={"/addfranchise"}
            // filterButtonName={"Filter"}
          />
          <div className="row">
            <div className="col-xl-12 col-xxl-12">
              <div className="card">
                <FilterModalComponent
                  heading={"Filter Franchise"}
                  searchItemValue={filter.search_text}
                  searchItemChange={(e) =>
                    setfilter({
                      ...filter,
                      search_text: e.target.value,
                    })
                  }
                  clearFilter={(e) => {
                    e.preventDefault();
                    window.location.reload();
                    localStorage.removeItem("franchise_filter");
                    setfilter({ ...filter, id: "", search_text: "" });
                  }}
                  submitFilter={(e) => {
                    e.preventDefault();
                    getData();
                    localStorage.setItem(
                      " franchise_filter",
                      JSON.stringify(filter)
                    );
                  }}
                >
                  {is_superuser && (
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="text-black font-w600">
                          Franchise <span className="required"></span>
                        </label>
                        <select
                          value={filter.id}
                          class="form-control form-control-lg"
                          onChange={(e) =>
                            setfilter({
                              ...filter,
                              id: e.target.value,
                            })
                          }
                        >
                          <option value={""} id={""}>
                            All
                          </option>
                          {restrarent?.data?.map((item) => (
                            <option value={item.id} id={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )}
                </FilterModalComponent>

                <div className="card-body most-favourite-items pb-0">
                  <div className="tab-content">
                    <div
                      className="tab-pane fade show active"
                      id="all-categories"
                    >
                      <div className="row">
                        {data.data.length > 0 ? (
                          data.data.map((item, index) => {
                            let data_img =
                              "https://static.thenounproject.com/png/2879926-200.png";
                            if (item.images && item.images.length > 0) {
                              data_img = item.images[0].image;
                            }
                            return (
                              <div id={item.id} className="col-lg-4 mb-2">
                                <div className="media mb-4 align-items-center applyborder p-2">
                                  <a
                                    className="text-black"
                                    href={`/franchise/${item.id}`}
                                  >
                                    {/* <div style={{ width: "100px", position: "absolute", height: "100px" }}>
                                      <strong style={{ position: 'absolute', bottom: 0, width: "100px", backgroundColor: item.product_count === 0 ? "#de0202" : "#51B04A", fontSize: "13px", color: "white", borderRadius: "10px", padding: 5, textAlign: "center", }}>{item.product_count === 0 ? "No Products" : item.product_count + " Products"}</strong>
                                    </div> */}

                                    {/* {!item.is_blocked && <strong style={{ position: 'absolute', backgroundColor: "#de0202", color: "white", borderTopLeftRadius: "10px", borderBottomRightRadius: "10px", paddingLeft: "5px", paddingRight: "5px", fontSize: "13px", paddingTop: "2px", marginBottom: "1px" }}>Blocked</strong>} */}
                                    {item.is_blocked && (
                                      <div
                                        style={{
                                          width: "100px",
                                          position: "absolute",
                                          height: "100px",
                                          borderRadius: "10px",
                                          marginRight: 15,
                                          borderWidth: "2px",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        <strong
                                          style={{
                                            color: "white",
                                            fontSize: "16px",
                                            width: "100%",
                                            marginVertical: 10,
                                            backgroundColor: "black",
                                            textAlign: "center",
                                            padding: 3,
                                          }}
                                        >
                                          Blocked
                                        </strong>
                                      </div>
                                    )}
                                    <div
                                      style={{
                                        height: "100px",
                                        width: "100px",
                                        borderRadius: "10px",
                                        marginRight: 15,
                                        borderWidth: "2px",
                                        border: "2px solid #000",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flex: 1,
                                        fontSize: "32px",
                                        fontWeight: "bold",
                                        textTransform: "uppercase",
                                        backgroundColor: random_rgba(),
                                      }}
                                    >
                                      {FirstLetterOfWords(item.name)}
                                    </div>
                                  </a>

                                  <div className="media-body">
                                    <span className="fs-16 text-black">
                                      <a
                                        className="text-black"
                                        href={`/franchise/${item.id}`}
                                      >
                                        {item.name}
                                      </a>
                                    </span>
                                    <br />
                                    {item.mobile && (
                                      <span className="fs-12 text-black">
                                        {item.mobile?.mobile}
                                        <br />
                                      </span>
                                    )}

                                    {item.place && (
                                      <span className="fs-12 text-black">
                                        {item.place?.place}
                                        <br />
                                      </span>
                                    )}

                                    <span className="fs-12 text-black">
                                      Total Restaurants {item.rest_num}
                                    </span>
                                    <br />
                                    {item.commission == 0 ? (
                                      <div
                                        style={{
                                          marginTop: "10px",
                                          border: "1px solid red",
                                          borderRadius: "5px",
                                          padding: "3px",
                                          borderColor: "red",
                                          backgroundColor: "red",
                                          color: "white",
                                          fontWeight: "bold",
                                          fontSize: 12,
                                        }}
                                      >
                                        Commission Not Set
                                      </div>
                                    ) : (
                                      <div
                                        className="mt-2"
                                        style={{
                                          marginTop: "10px",
                                          border: "1px solid red",
                                          borderRadius: "5px",
                                          padding: "3px",
                                          borderColor: "#51B04A",
                                          fontWeight: "bold",
                                          color: "white",
                                          backgroundColor: "#51B04A",
                                          fontSize: 12,
                                        }}
                                      >
                                        Commission : {item.commission}%
                                      </div>
                                    )}
                                    <span className="fs-12 text-black">
                                      <div className="row">
                                        {/* <span className="col mt-2">{restaurant.is_featured ? " Featured" : "Not Featured"}</span> */}

                                        {/* <div className="col" style={{ display: 'flex', marginTop: "5px" }}>
                                          <span>Is Blocked &nbsp;</span>
                                          <ToggleButton
                                            inactiveLabel={''}
                                            activeLabel={''}
                                           
                                            value={item.is_blocked || false}
                                            checked={item.is_blocked}
                                            thumbStyle={{ borderradius: 5 }}
                                            trackStyle={{ borderradius: 5 }}
                                            onToggle={
                                              (e) => {
                                                setIs_blocked({ ...is_blocked, is_blocked: !e, id: item.id })
                                                var x = { ...is_blocked, is_blocked: !e, id: item.id }
                                                let result = ManageFeatured(e, x, 'update', '')
                                                result.then(result => {
                                                  if (result.data.Status === true) {
                                                    var newData = data.data
                                                    var newObj = newData[index]
                                                    newObj = { ...newObj, is_blocked: !e }
                                                    newData[index] = newObj
                                                    setData({ ...data, data: newData })
                                                    setReload(!reload)
                                                  }
                                                  else {
                                                    showMessage(result.data.Error, "danger", "Error!", "top", "top-right", 0)

                                                  }
                                                })
                                                  .catch((error) => {
                                                  })
                                              }
                                            }
                                          />
                                        </div> */}
                                      </div>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <NoDataComponent data="Franchises" />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <LoadingComponent />
      )}
    </div>
  );
}
function Franchises() {
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header
          name={"Franchises"}
          subHeading={"All Franchises under foodoor"}
        />
        <NavBar />
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default Franchises;
